"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_country__international__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "19791495-a4c3-47cf-8c9c-0c3ff2013ce5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96.29,
    r: 80,
    fill: "none"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "ef196ee9-6a3c-4cb8-89a3-4da540934646",
    "data-name": "Country_international_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96.29,
    r: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.29a80,80,0,0,0,80-79c0,.33,0,.66,0,1a80,80,0,0,1-160,0c0-.34,0-.67,0-1A80,80,0,0,0,96,174.29Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#19791495-a4c3-47cf-8c9c-0c3ff2013ce5)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,55.29c0,11.6,31.34,21,70,21s70-9.4,70-21",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,23.79c0,5.8,15.67,10.5,35,10.5s35-4.7,35-10.5",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,139.29c0,11.6,31.34,21,70,21s70-9.4,70-21",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "394e92df-32e6-42b6-b10b-d9adbece7492",
    "data-name": "<Pfad>",
    d: "M90.65,12.71C65.57,34.23,47.75,63.28,47.75,95.5c0,31.78,18.27,61.38,42.9,82.79",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "eb6bde22-0dcf-413d-974d-caaae6cc0751",
    "data-name": "<Pfad>",
    d: "M104.72,12.71c25.08,21.52,42.9,50.57,42.9,82.79,0,31.78-18.27,61.38-42.9,82.79",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "a68d7c06-33c1-426c-964b-8a84a3f9bcf3",
    "data-name": "<Pfad>",
    x1: 97.68,
    y1: 178.29,
    x2: 97.68,
    y2: 14.41,
    opacity: 0.06,
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,97.29c0,13.92,37.61,25.2,84,25.2s84-11.28,84-25.2",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.2
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 192 192 192 192 0 0 0 0 192",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "country-or-international-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "880414e9-2376-4bcb-a9ee-dfdb5c6164c2",
    "data-name": "Country_Internet_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "79a83c09-a361-44f7-a585-f6607e827d94",
    "data-name": "Country_international_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0)",
    xlinkHref: "#ef196ee9-6a3c-4cb8-89a3-4da540934646"
  })));
}

var _default = ic_country__international__dark;
exports.default = _default;